module.exports = __webpack_public_path__ + "static/media/juan.559b328e.png";